import { useEffect, useState } from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";

import { TeamHeading, PageHeading } from "@/components/Layout/Parts";
import { Controls, ControlsButton } from "@/components/Controls";
import YoutubeProperties from "./components/YoutubeProperties";
import FacebookProperties from "./components/FacebookProperties";
import useAlerts from "@/hooks/useAlerts";

const Header = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0 0 24px;
  justify-content: space-between;
`;

enum Tabs {
  YOUTUBE_PROPERTIES,
  FACEBOOK_PROPERTIES,
}

const TestingSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const alerts = useAlerts();

  const tabToNavigate = searchParams.get("tab");
  const authorizationStatus = searchParams.get("authorization");

  const [activeTab, setActiveTab] = useState<Tabs>(Tabs.YOUTUBE_PROPERTIES);

  const headings = {
    [Tabs.YOUTUBE_PROPERTIES]: `Youtube properties`,
    [Tabs.FACEBOOK_PROPERTIES]: `Facebook properties`,
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case Tabs.YOUTUBE_PROPERTIES:
        return <YoutubeProperties />;
      case Tabs.FACEBOOK_PROPERTIES:
        return <FacebookProperties />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (tabToNavigate !== "facebook") return;

    setActiveTab(Tabs.FACEBOOK_PROPERTIES);
    setSearchParams(
      {},
      {
        replace: true,
      }
    );
  }, [tabToNavigate, setSearchParams]);

  useEffect(() => {
    switch (authorizationStatus) {
      case "success":
        alerts.success("Authorization successful!");
        break;
      case "error":
        alerts.error("Authorization failed!");
        break;
    }
  }, [authorizationStatus, alerts]);

  return (
    <>
      <TeamHeading />
      <PageHeading>Testing Settings</PageHeading>
      <Header>
        <Controls>
          <ControlsButton
            active={activeTab === Tabs.YOUTUBE_PROPERTIES}
            onClick={() => setActiveTab(Tabs.YOUTUBE_PROPERTIES)}
          >
            {headings[Tabs.YOUTUBE_PROPERTIES]}
          </ControlsButton>
          <ControlsButton
            active={activeTab === Tabs.FACEBOOK_PROPERTIES}
            onClick={() => setActiveTab(Tabs.FACEBOOK_PROPERTIES)}
          >
            {headings[Tabs.FACEBOOK_PROPERTIES]}
          </ControlsButton>
        </Controls>
      </Header>
      {renderActiveTab()}
    </>
  );
};

export default TestingSettings;
